import { render, staticRenderFns } from "./NotShippedGoods.vue?vue&type=template&id=0aab0872&scoped=true"
import script from "./NotShippedGoods.vue?vue&type=script&lang=js"
export * from "./NotShippedGoods.vue?vue&type=script&lang=js"
import style0 from "./NotShippedGoods.vue?vue&type=style&index=0&id=0aab0872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab0872",
  null
  
)

export default component.exports